var _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadioSelectedi = function SvgRadioSelectedi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color || 'currentColor'
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-4.967 0-9 4.033-9 9s4.033 9 9 9 9-4.033 9-9-4.033-9-9-9m0 1.4c4.195 0 7.6 3.405 7.6 7.6s-3.405 7.6-7.6 7.6-7.6-3.405-7.6-7.6S7.805 4.4 12 4.4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadioSelectedi);
export default ForwardRef;